import {
  AMOUNT_PREMIUM_THRESHOLD,
  INCOME_PREMIUM_THRESHOLD
} from 'constants/components'
import { isYoungOrMiddleAgeGroup } from 'stores/helpers/AgeGroups'

export function isPremiumCustomer({
  debtorsAge,
  amount,
  income
}: {
  debtorsAge: number
  amount: number
  income: { primary: number }
}) {
  return (
    isYoungOrMiddleAgeGroup(debtorsAge) &&
    amount >= AMOUNT_PREMIUM_THRESHOLD &&
    income.primary >= INCOME_PREMIUM_THRESHOLD
  )
}
